import React from 'react';
import InputMask from "@mona-health/react-input-mask";



const MaskedTextField = (props: any): React.JSX.Element => {
  return (
    <>
      {props.disabled ? (
        <InputMask
          {...props}
          mask={props.mask}
          maskPlaceholder={props.maskPlaceholder || ''}
          onChange={props.onChange}
          onFocus={props.onFocus}
          onBlur={props.onBlur}
          disabled
        >
          {props.children}
        </InputMask>
      ) : (
        <InputMask
          {...props}
          mask={props.mask}
          maskPlaceholder={props.maskPlaceholder || ''}
          onChange={props.onChange}
          onFocus={props.onFocus}
          onBlur={props.onBlur}
        >
          {props.children}
        </InputMask>
      )}
    </>
  );
};

export default MaskedTextField;
